import React, { useState, useEffect } from "react";
import { useAppContext } from "../../../../../../AppContext";
import axios from "axios";
import Window from "../../../../elements/window";
import Slide1 from "./slides/slide1";

import Loader from "../../../../../settings/loader";
import { exportPdf } from "../../../../../exportPdf";
import "./style.scss";

function OutletTargets(props) {
  const { user, chimeraserv } = useAppContext();
  const [data, setData] = useState({
    result: {
      brands: [], // Initialize with empty array instead of null
    },
    state: false,
  });
  const [load, setLoad] = useState(0);
  const [error, setError] = useState(null);
  const [exportData, setExportData] = useState(null);
  const [triggerExport, setTriggerExport] = useState(false);

  useEffect(() => {
    async function fetchOutletData() {
      try {
        if (!user || !user.data || !user.data.usrKey) {
          throw new Error("User data not available");
        }

        if (!chimeraserv || !chimeraserv.urlGet) {
          throw new Error("Chimeraserv not available");
        }

        const headers = {
          Authorization: user.data.usrKey,
          "Content-Type": "application/json",
          Accept: "application/json",
        };

        // Fix: Declare getUrl properly and fix the condition
        let getUrl = "";
        if (user.data.type === "admin" && user.data.group === "") {
          getUrl = `${chimeraserv.urlGet}/group`;
        } else {
          getUrl = `${chimeraserv.urlGet}/group/${user.data.group}`;
        }

        // Fix: Use axios instead of fetch for consistency with other parts of the codebase
        const response = await axios.get(getUrl, { headers });
        const result = response.data;

        // Handle different response structures
        let brands = [];

        // Fix: Handle both array and single object responses
        if (Array.isArray(result)) {
          result.forEach((groupObject, index) => {
            if (
              groupObject &&
              groupObject.brands &&
              Array.isArray(groupObject.brands)
            ) {
              // Add group information to each brand for identification
              const brandsWithGroupInfo = groupObject.brands.map((brand) => ({
                ...brand,
                groupId: groupObject._id || groupObject.id,
                groupName: groupObject.name || `Group ${index + 1}`,
                groupIndex: index,
              }));

              // Combine with existing brands array
              brands = brands.concat(brandsWithGroupInfo);
            }
          });
        } else if (result && result.brands) {
          // If result is a single object, get brands directly
          brands = result.brands || [];
        }

        setData({
          result: {
            brands: brands,
          },
          state: true,
        });
        setLoad(1);
        setError(null);
      } catch (error) {
        console.error("Error fetching outlet data:", error);
        setError(error.message);

        // Set data with empty brands but still mark as loaded
        setData({
          result: {
            brands: [],
          },
          state: true,
        });
        setLoad(1);
      }
    }

    if (!load && user && chimeraserv) {
      fetchOutletData();
    }
  }, [user, chimeraserv, load]);

  const handleExport = () => {
    setTriggerExport(true);
  };

  const handleGetData = (data) => {
    if (data) {
      exportPdf.table(data);
    }
    setTriggerExport(false);
  };

  return (
    <div className="device-analytics-view">
      <div className="view-header">
        <div className="viewTitle">Outlets Target For the Day</div>

        {/* <button className="export-button" onClick={handleExport}>
          Export Report
        </button> */}
      </div>

      {!load ? (
        <Loader />
      ) : (
        <>
          <Window
            user={props.user}
            chimeraserv={props.chimeraserv}
            title={"Outlets Target For the Day"}
            horizontal
          >
            <Slide1
              data={data}
              export={triggerExport}
              getData={handleGetData}
            />
          </Window>
        </>
      )}
    </div>
  );
}

export default OutletTargets;
